import { Dispatch } from "redux";
import { createAction } from "redux-actions";

const resetReduxState = createAction("redux/RESET_STATE");
export const resetApp =
  () =>
  (dispatch: Dispatch): void => {
    dispatch(resetReduxState());
  };
